import client from '@/api/client';

// First multipart call in the app — client.ts sets a default 'application/json' Content-Type via
// axios.create, so it must be cleared per-request to let axios set the multipart boundary itself.
export async function uploadReceipt(file: File, hostelId: string, tenantId: string): Promise<string> {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('hostelId', hostelId);
  fd.append('tenantId', tenantId);
  const res = await client.post('/api/receipts/upload', fd, {
    headers: { 'Content-Type': undefined },
  });
  return (res as unknown as { receiptUrl: string }).receiptUrl;
}
